import styled from 'styled-components';

const Contenedor = styled.div`
    width: 100%;
    min-height: 100vh;
    position: relative;
    z-index: 1;
`;

export default Contenedor;